/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { Text, TouchableOpacity, View } from 'react-native';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { styles } from './CatalogMastersScreen.styles';

type Props = {
  icon: keyof typeof Ionicons.glyphMap;
  title: string;
  message: string;
  canEdit?: boolean;
  createLabel?: string;
  onCreate?: () => void;
  /** Acción de reintento para estados de error (llama al reload de la sección). */
  retryLabel?: string;
  onRetry?: () => void;
};

export function MastersEmptyState({
  icon,
  title,
  message,
  canEdit,
  createLabel,
  onCreate,
  retryLabel = 'Reintentar',
  onRetry,
}: Props) {
  return (
    <View style={styles.listEmpty}>
      <View style={styles.listEmptyIconWrap}>
        <Ionicons name={icon} size={26} color={ticketColors.gold} />
      </View>
      <Text style={styles.listEmptyTitle}>{title}</Text>
      <Text style={styles.listEmptyText}>{message}</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
        {onRetry ? (
          <TouchableOpacity
            style={[styles.primaryButton, styles.listEmptyCta]}
            onPress={onRetry}
            accessibilityRole="button"
            accessibilityLabel={retryLabel}
          >
            <Ionicons name="refresh" size={18} color={ticketColors.goldInk} />
            <Text style={styles.primaryButtonText}>{retryLabel}</Text>
          </TouchableOpacity>
        ) : null}
        {canEdit && createLabel && onCreate ? (
          <TouchableOpacity
            style={[onRetry ? styles.secondaryButton : styles.primaryButton, styles.listEmptyCta]}
            onPress={onCreate}
            accessibilityRole="button"
            accessibilityLabel={createLabel}
          >
            <Ionicons name="add" size={18} color={onRetry ? ticketColors.ink : ticketColors.goldInk} />
            <Text style={onRetry ? styles.secondaryButtonText : styles.primaryButtonText}>
              {createLabel}
            </Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
}
